export default __webpack_public_path__ + "static/N0138-1e96804860fe6352ca4d895c39f71827.png";